var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.821 -0.12 33 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9D93A",
    d: "M13.903,21.772c-2.303,1.844-6.562,5.262-9.487,5.168c-2.808-0.088-5.111-2.74-4.222-5.572 c0.854-2.708,4.414-6.301,6.681-7.962c0.261-0.19,0.331-0.548,0.162-0.822C5.106,9.452,1.352,4.08,5.654,1.06 c4.434-3.119,8.592,1.295,10.883,4.869c0.288,0.457,0.894,0.591,1.353,0.3c0.061-0.038,0.116-0.083,0.167-0.132 c2.671-2.683,10.347-7.16,12.669-1.855c0.876,2,0.583,3.899-0.878,5.697c-2.063,2.532-3.896,4.482-5.497,5.852 c-0.171,0.143-0.223,0.385-0.125,0.585c0.133,0.262,0.861,1.293,2.186,3.095c1.102,1.5,2.018,3.872,1.868,5.896 c-0.096,1.345-0.857,2.488-2.285,3.431c-0.889,0.585-2.013,0.805-3.374,0.66c-3.344-0.355-6.369-4.957-8.057-7.577 c-0.134-0.208-0.413-0.268-0.624-0.132C13.926,21.755,13.915,21.764,13.903,21.772z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroMark);
export default __webpack_public_path__ + "static/media/hero-mark.50bc5121f23323be3e0f9ad3f400d038.svg";
export { ForwardRef as ReactComponent };